/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import DistrictContainer from './districts/container/DistrictContainer';
import BarangayContainer from './barangays/container/BarangayContainer';
import LocationContainer from './locations/container/LocationContainer';
import StreetContainer from './streets/container/StreetContainer';

function PropertyLocationRoutes({ match, pathName }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['E2E RPT SETTINGS LOCATION DISTRICTS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/property-locations/districts"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf(
                        'rpt/settings/property-locations/districts'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Districts
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT SETTINGS LOCATION BARANGAYS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/property-locations/barangays"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf(
                        'rpt/settings/property-locations/barangays'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Barangays
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT SETTINGS LOCATION LOCATIONS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/property-locations/locations"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf(
                        'rpt/settings/property-locations/locations'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Locations
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT SETTINGS LOCATION STREET']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/property-locations/streets"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf(
                        'rpt/settings/property-locations/streets'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Streets
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['E2E RPT SETTINGS LOCATION DISTRICTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/districts`} />}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS LOCATION DISTRICTS']) && (
            <Route
              path={`${match.path}/districts`}
              component={DistrictContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS LOCATION BARANGAYS']) && (
            <Route
              path={`${match.path}/barangays`}
              component={BarangayContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS LOCATION LOCATIONS']) && (
            <Route
              path={`${match.path}/locations`}
              component={LocationContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS LOCATION STREET']) && (
            <Route path={`${match.path}/streets`} component={StreetContainer} />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

PropertyLocationRoutes.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(PropertyLocationRoutes);
